module.exports = __webpack_public_path__ + "static/media/cal1.9bd52cc8.PNG";